import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, Heart } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer 
      role="contentinfo"
      aria-label="Site footer"
      className="border-t border-border/50 bg-secondary/30 py-8"
    >
      <div className="container px-4 md:px-6">
        <div className="flex flex-col items-center gap-6">
          {/* Logo and Brand */}
          <div className="flex items-center gap-2">
            <div 
              className="flex h-8 w-8 items-center justify-center rounded-lg bg-gradient-to-br from-primary to-blue-600"
              aria-hidden="true"
            >
              <BookOpen className="h-4 w-4 text-primary-foreground" />
            </div>
            <span className="font-semibold">TOPPERS BUDDY</span>
          </div>

          {/* Policy Links */}
          <nav className="flex flex-wrap justify-center gap-4 text-sm" aria-label="Policy navigation">
            <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors">
              Contact Us
            </Link>
            <span className="text-border">|</span>
            <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
              Terms & Conditions
            </Link>
            <span className="text-border">|</span>
            <Link to="/refund-policy" className="text-muted-foreground hover:text-primary transition-colors">
              Refunds & Cancellations
            </Link>
          </nav>

          {/* Made with love */}
          <p className="flex items-center gap-1 text-sm text-muted-foreground">
            Made with <Heart className="h-4 w-4 fill-destructive text-destructive" aria-label="love" /> for Class 10 Students
          </p>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground">
            © {currentYear} Toppers Buddy. All rights reserved. <span className="text-xs opacity-50">v2.1</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
